module.exports = __webpack_public_path__ + "img/KTV.a9bd769e.png";